import React from 'react'
import propTypes from 'prop-types'

export default class FlashMessage extends React.Component {
  componentDidMount () {
    this.timer = setTimeout(
      this.props.onClose,
      this.props.timeout
    )
  }

  componentWillUnmount () {
    clearTimeout(this.timer)
  }

  alertClass (type) {
    let classes = {
      error: 'alert-danger',
      alert: 'alert-warning',
      notice: 'alert-info',
      success: 'alert-success'
    }
    return classes[type] || classes.success
  }

  render () {
    const message = this.props.message
    const alertClassName = `alert ${this.alertClass(message.type)} fade in`
    return (<div className={alertClassName} style={{display: 'flex'}}>
      <div >{ message.text }</div>
      <div className='close' style={{marginLeft: '10px'}}
        onClick={this.props.onClose}>
                    &times;
      </div>

    </div>
    )
  }
}

FlashMessage.propTypes = {
  onClose: propTypes.func,
  timeout: propTypes.number,
  message: propTypes.object.isRequired
}

FlashMessage.defaultProps = {
  timeout: 3000
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/flashMessages/FlashMessage.js